/* eslint-disable office-addins/no-navigational-load */
/* global Word */
import { applyRangeChanges } from "../elements/runs";
import { CanvasChange, getType, isDocumentElement, ParseState } from "../types";
import { handleAddElement } from "./add";
import { handleRemoveElement } from "./remove";

export async function handleUpdate(
  change: CanvasChange,
  context: Word.RequestContext,
  target: Word.Paragraph | Word.Range,
  allElementsInDocument: Word.Paragraph[],
  state: ParseState
) {
  const oldType = getType(change.e1);
  const newType = getType(change.e2);
  if (oldType !== newType) {
    throw new Error("Element type mismatch");
  }
  if (target instanceof Word.Paragraph) {
    if (!isDocumentElement(change.e1) || !isDocumentElement(change.e2)) {
      throw new Error("Invalid element type");
    }
    if (change.e1.type !== change.e2.type) {
      await handleAddElement(target, context.document, change.e2, state, false, allElementsInDocument, context);
      handleRemoveElement(target);
    } else {
      if (change.e1.prefix !== change.e2.prefix) {
        // TODO: Handle prefix changes
      }
      if (change.e1.tabs !== change.e2.tabs) {
        target.leftIndent = change.e2.tabs * 0.25 * 72;
      }
      if (change.child_changes) {
        const targetRuns = target.getTextRanges([], true);
        targetRuns.load("items");
        await context.sync();
        await applyRangeChanges(change, context, targetRuns.items, state);
      }
    }
  }
}
